import { Styles } from '@types'
import { Form, Modal } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import { Buffer } from 'buffer'
import dayjs, { Dayjs } from 'dayjs'
import { PaymentSearch } from 'gadjet-v2-types/dist/type/search'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import bufferToFileDownload from '@utils/download'
import formRule from '@utils/formRule'

import PaymentAPI from '@apis/branch/payment'

import { RootState } from '@reducers/index'

import LocalDatePicker from '@components/atoms/LocalDatePicker'

type Props = {
  hqId: number
  branchId: number
  search: PaymentSearch
  visible: boolean
  onClose: () => void
  onDone?: () => void
}

export default function PaymentExportModal({
  hqId,
  branchId,
  search,
  visible,
  onClose,
  onDone = () => undefined,
}: Props): JSX.Element {
  const [loading, setLoading] = useState(false)
  const [form] = useForm<{ dateRange: [Dayjs, Dayjs] }>()
  const branchName = useSelector((state: RootState) => state.branch.name)
  const { date, paymentStatus, paymentType, query } = search
  const onOk = async () => {
    const { dateRange } = await form.validateFields()

    setLoading(true)
    const { data } = await PaymentAPI.exportPayments(
      { hqId, branchId },
      {
        date: [dateRange[0].format('YYYY-MM-DD'), dateRange[1].format('YYYY-MM-DD')],
        paymentStatus,
        paymentType,
        query,
      }
    )

    const today = dayjs().format('YYMMDD')
    bufferToFileDownload(`${branchName}_입금_${today}.xlsx`, Buffer.from(data.data))

    setLoading(false)
    onDone()
  }

  const initialValues = { dateRange: [dayjs(date[0]), dayjs(date[1])] }

  const onReset = () => {
    form.resetFields()
    setLoading(false)
  }

  useEffect(() => {
    if (visible) onReset()
  }, [visible])

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      onOk={onOk}
      title="결제내역 다운로드"
      okText="다운로드"
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical" initialValues={initialValues}>
        <Form.Item label="기간" name="dateRange" rules={[formRule.required]}>
          <LocalDatePicker.RangePicker size="large" style={styles.datePicker} allowClear={false} />
        </Form.Item>
      </Form>
    </Modal>
  )
}

const styles: Styles = {
  datePicker: { width: '100%' },
}
